import { gql }  from '@apollo/client';

const FETCH_DATA_FOR_RECENT_CONSULTATIONS_TABLE = gql`
  query($memberId: ID!) {
    member(id: $memberId) {
      id
      internalReferralRecentConsultations
    }
  }
`;

 export default FETCH_DATA_FOR_RECENT_CONSULTATIONS_TABLE;
